import clsx from 'clsx'
import { PageProps, graphql } from 'gatsby'
import { useEffect } from 'react'

import { Page, indexLayout } from '@karakuri-web/faq-component'
import { SearchParams } from '@karakuri-web/faq-type'

import IndexLayout from '../layouts'
import { loadDictionary } from '../utils/dictionary'
import { Data } from '../widgets/interface'
import { renderIndexPageWidget } from '../widgets/pages'
import { SEOWidget as SEO } from '../widgets/SEOWidget'

type Props = PageProps<Data, Record<string, unknown>, SearchParams>
export default function IndexPage({ data, location }: Props) {
  useEffect(() => {
    loadDictionary()
  }, [])
  const widgetProps = {
    data,
    location,
  }
  const { left, right, main } = indexLayout(data.settingYaml)
  const title = data.settingYaml?.words?.index?.title ?? 'よくあるご質問 TOP'
  const headTitle =
    data.settingYaml?.words?.index?.headTitle ?? (data.settingYaml.title || 'よくあるご質問')
  return (
    <IndexLayout className="faq-index-layout">
      <SEO pathname={location.pathname} title={headTitle} />
      <Page
        className={clsx('faq-content', {
          'faq-has-sidebar': left.length > 0 || right.length > 0,
        })}
      >
        <div className="faq-main-content">
          <div className="faq-header">
            <h2>{title}</h2>
          </div>
          {renderIndexPageWidget(main, widgetProps)}
        </div>
        <div className={clsx('faq-left-content', { 'faq-no-content': left.length === 0 })}>
          {renderIndexPageWidget(left, widgetProps)}
        </div>
        <div className={clsx('faq-right-content', { 'faq-no-content': right.length === 0 })}>
          {renderIndexPageWidget(right, widgetProps)}
        </div>
      </Page>
    </IndexLayout>
  )
}

export const query = graphql`
  fragment SubRecursive on SettingYamlCategorySub {
    id
    title
    sub {
      ...Sub
      sub {
        ...Sub
        sub {
          ...Sub
          sub {
            ...Sub
            sub {
              ...Sub
              sub {
                ...Sub
                sub {
                  ...Sub
                  sub {
                    ...Sub
                    sub {
                      ...Sub
                      sub {
                        ...Sub
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment Sub on SettingYamlCategorySub {
    id
    title
  }

  fragment Layout on Layout {
    id
    title
    type
    data
    icons {
      id
      title
      reference
      image
    }
  }

  query IndexData {
    settingYaml(ignore: { ne: true }) {
      botId
      tenantId
      title
      layout
      layoutMain {
        ...Layout
      }
      layoutLeft {
        ...Layout
      }
      layoutRight {
        ...Layout
      }
      informations {
        id
        title
      }
      importants {
        id
        title
      }
      categories {
        id
        title
        sub {
          ...SubRecursive
        }
      }
      words {
        index {
          title
          headTitle
        }
        search {
          placeholder
          keyword
          showKeyword
          hideKeyword
          resultMessage {
            success
            error
          }
        }
      }
      waitMs {
        complete
        search
      }
      useAutoSearch
      useSearchWithCategory
      useMoveToCategoryPageOnClickCategory
      useKnowledgeSearch
      searchType
      queryThreshold
    }
  }
`
